import React, { useState } from 'react';
import { TabProps, TabItem } from '../../../types/DesignSystem/Tab';
import Typography from '../Typography/Typography';

const Tab: React.FC<TabProps> = ({
  tabs,
  activeTabId,
  onChange,
  variant = 'default',
  className = '',
}) => {
  const [internalActiveTabId, setInternalActiveTabId] = useState<string | number>(
    activeTabId || tabs[0]?.id
  );

  const currentActiveTabId = activeTabId !== undefined ? activeTabId : internalActiveTabId;

  const handleTabClick = (tabId: string | number, disabled?: boolean) => {
    if (!disabled) {
      setInternalActiveTabId(tabId);
      onChange?.(tabId);
    }
  };

  const activeTab = tabs.find((tab) => tab.id === currentActiveTabId);

  return (
    <div className={`tw-flex tw-flex-col ${className}`}>
      <div className="tw-flex tw-border-b tw-border-grey-200">
        {tabs.map((tab: TabItem) => {
          const isActive = tab.id === currentActiveTabId;
          const isDisabled = tab.disabled;

          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id, isDisabled)}
              disabled={isDisabled}
              className={`tw-px-4 tw-py-3 tw-font-medium tw-text-sm tw-transition-colors tw-border-b-2 ${
                isActive
                  ? 'tw-border-blue-500 tw-text-blue-500'
                  : 'tw-border-transparent tw-text-grey-600 hover:tw-text-blue-500'
              } ${
                isDisabled
                  ? 'tw-opacity-50 tw-cursor-not-allowed tw-text-grey-400'
                  : 'tw-cursor-pointer'
              }`}
              role="tab"
              aria-selected={isActive}
              aria-disabled={isDisabled}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {activeTab && activeTab.content && (
        <div className="tw-mt-4 tw-p-4 tw-bg-white tw-rounded tw-border tw-border-grey-100">
          {activeTab.content}
        </div>
      )}
    </div>
  );
};

export default Tab;
